import { AxiosResponse } from 'axios';
import agent from 'src/api_v2/base';
import { QuizConfigurationType } from 'src/containers_v2/puzzle/quiz/quiz-configuration/store/slice';
import { FetchQuizListParams, QuizListPageResult } from './types';

class QuizApi {
  async fetchQuizCategory() {
    try {
      const response: AxiosResponse = await agent.get(
        `/qa-category`
      );

      if (response.status === 200) {
        return response.data as QuizListPageResult;
      }

      return []
    } catch (err) {
      throw new Error(err);
    }
  }
  
  async getQuizDifficulty() {
    try {
      const response: AxiosResponse = await agent.get(
        `/qa-difficulty`
      );

      if (response.status === 200) {
        return response.data as QuizListPageResult;
      }

      return []
    } catch (err) {
      throw new Error(err);
    }
  }
  
  async fetchQuizList(params: FetchQuizListParams) {
    try {
      const response: AxiosResponse = await agent.get(
        `/qa-return/${params.toString()}`
      );

      if (response.status === 200) {
        return response.data as QuizListPageResult;
      }

      return []
    } catch (err) {
      throw new Error(err);
    }
  }

  async fetchRemainingCredit(user_id: number) {
    try {
      const response: AxiosResponse = await agent.get(
        `/quiz/${user_id}/remaining-credit`
      );

      if (response.status === 200) {
        return response.data as QuizListPageResult;
      }

      return []
    } catch (err) {
      throw new Error(err);
    }
  }

  async deleteQuiz(id: number) {
    try {
      const response: AxiosResponse = await agent.delete(
        `/${id}`
      );

      if(response.status !== 200) {
        return false
      } 

      return true
    } catch (err) {
      throw err;
    }
  }

  async addQuiz(quiz: QuizConfigurationType) {
    try {
      const response: AxiosResponse = await agent.post(
        `/qa/add`,
        quiz
      );

      if(response.status !== 200 && response.status !== 201) {
        return {
          valid : false,
          data: response
        }
      }

      return {
        valid : true,
        data: response
      }
    } catch (err) {
      return {
        valid : false,
        data: err
      };
    }
  }

  async updateQuiz(quiz: QuizConfigurationType) {
    try {
      const response: AxiosResponse = await agent.put(
        `/qa/update`,
        quiz
      );

      if(response.status !== 200 && response.status !== 204) {
        return {
          valid : false,
          data: response
        }
      }

      return {
        valid : true,
        data: response
      }
    } catch (err) {
      return {
        valid : false,
        data: err
      };
    }
  }

  async getQuiz(id: string): Promise<any> {
    try {
      const response: AxiosResponse = await agent.get(
        `/qa/${id}`
      );

      if (response.status === 200) {
        return response.data;
      }

      return undefined
    } catch (err) {
      throw err;
    }
  }
}

const quizListApi = new QuizApi();
export default quizListApi;
